module.exports = __webpack_public_path__ + "static/media/Writing.5be45f53.png";